package com.karawek.core.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily

// HIG type ramp — SF Pro Display for display/titles, SF Pro Text for everything else.
// display   = Large Title  34sp bold
// headline  = Headline     17sp semibold
// title     = Title 1      28sp bold
// title2    = Title 2      22sp bold
// title3    = Title 3      20sp semibold
// body      = Body         17sp regular
// callout   = Callout      16sp regular
// subhead   = Subhead      15sp regular  (replaces bodySecondary)
// caption   = Footnote     13sp regular
// footnote  = Caption 1    12sp regular
data class CoreTypographyScheme(
    val display: TextStyle,    // Large Title 34sp — screen titles, nav large
    val headline: TextStyle,   // Headline 17sp semibold — list headers, section titles
    val title: TextStyle,      // Title 1  28sp — modal titles
    val title2: TextStyle,     // Title 2  22sp
    val title3: TextStyle,     // Title 3  20sp
    val body: TextStyle,       // Body     17sp — primary reading text
    val callout: TextStyle,    // Callout  16sp — card body, supporting info
    val bodySecondary: TextStyle, // Subhead 15sp — secondary labels (kept for compat)
    val caption: TextStyle,    // Footnote 13sp — labels, badges, timestamps
    val footnote: TextStyle,   // Caption  12sp — fine print, helper text
) {

    fun toMaterialTypography(): Typography = Typography(
        displayLarge   = display,
        headlineMedium = headline,
        titleLarge     = title,
        titleMedium    = title2,
        titleSmall     = title3,
        bodyLarge      = body,
        bodyMedium     = bodySecondary,
        labelLarge     = caption,
        labelMedium    = footnote,
    )
}

internal expect fun createCoreTypographyScheme(): CoreTypographyScheme
